import { render } from "./ContentSurveyConfirm.vue?vue&type=template&id=3a0281f1&ts=true"
import script from "./ContentSurveyConfirm.vue?vue&type=script&lang=ts"
export * from "./ContentSurveyConfirm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__